<template>
  <div class="mobile-menu-item">
    <slot />
  </div>
</template>

<style lang="less" scoped>
.mobile-menu-item {
  display: flex;
  height: 54px;
  font-size: 14px;
  align-items: center;
}
</style>
